import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    flags: `${APP_CONFIG.care_cluster}/ms-features-flags`,
  },
}
